import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiDialog: ThemeOptions["components"] = {
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...typographyVariants.headingLarge,
        color: theme.palette.typography.headingLarge,
        marginTop: 25,
        [theme.breakpoints.down("sm")]: {
          ...typographyVariants.bodyMedium,
          color: theme.palette.typography.bodyMedium,
          textAlign: "center",
          marginTop: 10,
          marginBottom: 0,
        },
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      container: ({ theme, ownerState }) => ({
        ...typographyVariants.body,
        color: theme.palette.typography.body,
        alignItems: ownerState.fullScreen ? "flex-end" : "center",
        padding: 0,
        margin: 0,
      }),
      paper: ({ ownerState, theme }) => {
        const isPicker = (ownerState.id || "").includes("__picker__");
        return {
          borderRadius: 16,
          backgroundColor: theme.palette.background.default,
          padding: isPicker ? 0 : ownerState.fullScreen ? "0 16px" : "0 36px",
          [theme.breakpoints.up("md")]: {
            padding: ownerState.fullScreen ? "0 16px" : "0 106px",
          },
        };
      },
      paperFullScreen: ({ theme }) => ({
        justifyContent: "flex-end",
        margin: 0,
        height: "95%",
        backgroundColor: theme.palette.background.default,
        borderRadius: "16px 16px 0 0",
        padding: 0,
      }),
      paperWidthMd: {
        width: 824,
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({ theme }) => ({
        justifyContent: "center",
        paddingBottom: 48,
        [theme.breakpoints.down("sm")]: {
          boxShadow: theme.shadows[5],
          padding: 16,
          backgroundColor: theme.palette.background.default,
        },
      }),
    },
  },
};
